export default __webpack_public_path__ + "static/media/drag-and-drop.0af36cb8.png";